import React from 'react';

const ColumnSelectionModal = ({ 
  isOpen, 
  closeModal, 
  tempSelectedColumns, 
  toggleColumnSelection, 
  permanentColumns, 
  allColumns, 
  selectAll, 
  toggleSelectAll, 
  confirmSelection, 
  cancelSelection 
}) => {
  if (!isOpen) return null;

  return (
    <div className="column-selection-modal-overlay">
      <div className="column-selection-modal">
        <div className="column-selection-header">
          <h2>Select Fields</h2>
          <button
            className="modal-close-btn"
            onClick={closeModal}
          >
            &times;
          </button>
        </div>

        <div className="column-list-container">
          <div className="column-grid">
            {allColumns.map((column) => (
              <label
                key={column.key}
                className={`column-checkbox ${permanentColumns.includes(column.key) ? 'permanent' : ''}`}
              >
                <input className='check'
                  type="checkbox"
                  checked={tempSelectedColumns.includes(column.key)}
                  onChange={() => toggleColumnSelection(column.key)}
                  disabled={permanentColumns.includes(column.key)}
                />
                <span>{column.label}</span>
              </label>
            ))}
          </div>
        </div>

        <div className="column-dropdown-actions">
          <button className="select-all-btn" onClick={toggleSelectAll}>
            {selectAll ? 'Deselect All' : 'Select All'}
          </button>

          <button
            className="btn-ok"
            onClick={confirmSelection}
          >
            OK
          </button>
          <button
            className="btn-cancel"
            onClick={cancelSelection}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ColumnSelectionModal;